// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base variables */
:root {
    --insights-accent: #3B36F1;
    --insights-body-background-color: #FFFFFF;
    --insights-hover-btn-color: #FFFFFF;
    --insights-question-input-background: #F2F1FD;
    --insights-question-input-color: #6F8290;
    --insights-main-icon-background-color: #EFEFFE;
    --insights-main-icon-rect-fill: #fbf796;
    --insights-right-icon-exit-fill: #1F222A;
    --insights-refresh-stop-generating-btn-background-color: #FAEAEA;
    --insights-refresh-stop-generating-btn-color: #B2201A;
    --insights-refresh-stop-generating-btn-path-fill: #B2201A;
    --insights-refresh-refresh-new-btn-background-color: #E9F9E7;
    --insights-refresh-refresh-new-btn-color: #1E5C29;
    --insights-refresh-refresh-new-btn-path-fill: #1E5C29;
    --insights-loader-foreground-color: #eeeef1;
    --insights-loader-background-color: #dadadd;
    --insights-gradient-background-max: rgba(255, 255, 255, 1);
    --insights-gradient-background-min: rgba(255, 255, 255, 0);
    --insights-answer-reply-background: #EFEFFE;
    --insights-header-color: #000000;
    --insights-text-color: #47535C;
    --insights-question-color: #1F222A;
    --insights-scrollbar: #3c36f1c0;
    --insights-scrollbar-hover: #3c36f156;
    --insights-modal-shadow: 0px 0px 50px 0px #474747;
}

/* Dark mode overrides */
:root.dark-mode,
.insights-dark-mode {
    --insights-accent: #A5A3FA;
    --insights-body-background-color: #23272F;
    --insights-hover-btn-color: #23272F;
    --insights-question-input-background: #333A45;
    --insights-question-input-color: #8B91A7;
    --insights-main-icon-background-color: #333A45;
    --insights-main-icon-rect-fill: #333A45;
    --insights-right-icon-exit-fill: #EBECF0;
    --insights-refresh-stop-generating-btn-background-color: #404756;
    --insights-refresh-stop-generating-btn-color: #FA9494;
    --insights-refresh-stop-generating-btn-path-fill: #FA9494;
    --insights-refresh-refresh-new-btn-background-color: #404756;
    --insights-refresh-refresh-new-btn-color: #B3ECAC;
    --insights-refresh-refresh-new-btn-path-fill: #B3ECAC;
    --insights-loader-foreground-color: #434B5B;
    --insights-loader-background-color: #333A45;
    --insights-gradient-background-max: rgba(35, 39, 47, 1);
    --insights-gradient-background-min: rgba(35, 39, 47, 0);
    --insights-answer-reply-background: #333A45;
    --insights-header-color: #EBECF0;
    --insights-text-color: #C5C8D3;
    --insights-question-color: #EBECF0;
    --insights-scrollbar: #A5A3FA;
    --insights-scrollbar-hover: #8482C8;
    --insights-modal-shadow: 0px 0px 50px 0px #474747;
}

.insights {
    position: absolute;
    user-select: text !important;
    color: var(--insights-text-color);
}

.insights h1,
.insights h2,
.insights h3,
.insights h4,
.insights h5 {
    margin-block-start: 0.67em;
    margin-block-end: 1.34em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    color: var(--insights-header-color);
    font-weight: 700;
}

.insights * {
    font-family: noto sans !important;
}

.insights-body {
    z-index: 2;
    background-color: var(--insights-body-background-color);
    border-radius: 5px;
    border: none;
    position: absolute;
    top: 0;
    right: 2rem;
    width: 391px;
    box-shadow: var(--insights-modal-shadow);
}



/*  header */
.insights-header {
    display: flex;
    justify-content: space-between;
    cursor: move;
    padding-left: 9px !important;
    padding-right: 9px !important;
}

.insights-left,
.insights-middle,
.insights-right {
    flex: 1;
    display: flex;
}

.insights-left,
.insights-right {
    padding-top: 11px !important;
}

.insights-right {
    gap: 7px;
}

.insights-left .insights-hover-container,
.insights-right .insights-hover-container {
    position: relative;
    display: inline-block;
}

/* info hover card */
.insights-left .insights-hover-btn {
    background: var(--insights-accent);
    color: var(--insights-hover-btn-color);
    border-radius: 4px;
    border: none;
    transition: background-color 0.3s;
    padding: 4px 8px;
    font-size: 12px;
}

.insights-hover-card {
    cursor: auto;
    white-space: wrap;
    display: none;
    position: absolute;
    top: 70%;
    padding: 5px 10px 5px 10px !important;
    border: 1px solid #ccc;
    background: #47535CE5;
    border-radius: 5px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    color: #FFFFFF;
    z-index: 3;
    text-wrap: nowrap;
    font-weight: 400;
    font-size: 12px;
    overflow: hidden;
    word-wrap: break-word;
}

.insights-text strong {
    font-size: revert !important;
}

.insights-left .insights-hover-card {
    left: 0;
}

.insights-right .insights-hover-card {
    right: 0;
}


.insights-hover-container:hover .insights-hover-card {
    display: block;
}

.insights-right {
    justify-content: flex-end;
    /* max-width: 30%; */
}

.insights-right svg {
    cursor: pointer;
}

.insights-middle {
    flex-direction: column;
    align-items: center;
    padding-top: 20px !important;
}


/* next row title */
.insights-title {
    display: flex;
    justify-content: center;
    padding-top: 16px !important;
    padding-bottom: 24px !important;
}

.insights-title-text {
    font-weight: 700 !important;
    font-size: 18px;
    line-height: 24.51px;
    text-align: center;
}

/* body */
.insights-response-container {
    min-height: 10rem;
    overflow-y: auto;
    max-height: 300px;
    overflow-x: hidden;
    white-space: break-spaces;
}

.insights-gradient-top {
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    height: 50px;
    background: linear-gradient(var(--insights-gradient-background-max), var(--insights-gradient-background-min))
}

.insights-gradient-bottom {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;
    background: linear-gradient(var(--insights-gradient-background-min), var(--insights-gradient-background-max))
}

/* question */
.insights-question {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px !important;
}

.insights-question-input {
    flex-grow: 1;
    border: 0px;
    border-radius: 10px;
    padding: 10px;
    background: var(--insights-question-input-background);
    color: var(--insights-question-input-color);
    font-weight: 600;
    font-size: 14px !important;
    line-height: 16.34px !important;
    border: 1px solid transparent;
}

.insights-question-input:focus {
    border: 1px solid var(--insights-accent) !important;
    outline: none !important;
}

.insights-question-input:hover {
    border: 1px solid transparent;
    outline: none !important;
    border-color: transparent !important;
}

/* answer - question pair */
.question-pair-border-top {
    position: relative;
    left: 50%;
    width: 77%;
    border-top: 1px solid #C8CFD4;
    transform: translateX(-50%);
}

.insights-question-answer-pair {
    padding-top: 10px;
    padding-bottom: 5px;
    padding-left: 1rem;
    padding-right: 1rem;
    color: var(--insights-text-color);
}

.insights-answer-question {
    padding-top: 1rem !important;
    font-weight: 700;
    margin-left: 0.7rem !important;
    padding-bottom: 0.5rem !important;
}

.insights-current-reply,
.insights-answer-reply {
    display: flex;
    border: solid 1px var(--insights-accent);
    border-radius: 4px;
    margin-left: 19px !important;
    margin-right: 19px !important;
    background: var(--insights-answer-reply-background);
    margin-bottom: 15px !important;
}

.insights-current-reply>.insights-main-icon,
.insights-answer-reply>.insights-main-icon {
    padding-top: 11px !important;
    padding-right: 8px !important;
}


.insights-text {
    padding-left: 0.9rem !important;
    padding-right: 0.9rem !important;
}

.insights-text strong,
.insights-text h1,
.insights-text h2,
.insights-text h3,
.insights-text h4,
.insights-text h5,
.insights-text h6 {
    font-size: larger;
}

.insights-text *:not(strong):not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {
    font-size: 12px;
}

/* scroll bar */
.insights-response-container::-webkit-scrollbar {
    width: 8px;
    background-color: none;
}

.insights-response-container::-webkit-scrollbar-thumb {
    background-color: var(--insights-scrollbar);
    border-radius: 5px;
    transition: background-color 0.2s;
}

.insights-response-container::-webkit-scrollbar-thumb:hover {
    background-color: var(--insights-scrollbar-hover);
}

.insights-response-container::-webkit-scrollbar-button {
    display: none;
}

.insights-uninitialized {
    text-align: center;
    padding-top: 20px;
}

.insights-error {
    margin-top: 2rem;
}

.insights-outer-container {
    position: relative;
}

.insights-toggle-button {
    position: absolute;
    z-index: 1;
    cursor: pointer;
    border-radius: 50%;
    height: 32px;
    width: 32px;
    box-shadow: none;
    transition: box-shadow 1s;
}

.insights-toggle-button-hidden {
    opacity: 0;
    transition: opacity 0.5s ease-in;
    -webkit-transition: opacity 0.5s ease-in;
    -moz-transition: opacity 0.5s ease-in;
    -ms-transition: opacity 0.5s ease-in;
    -o-transition: opacity 0.5s ease-in;
}

.insights-outer-container:hover .insights-toggle-button-hidden {
    opacity: 1;
    transition: opacity 0.5s ease-out;
    -webkit-transition: opacity 0.5s ease-out;
    -moz-transition: opacity 0.5s ease-out;
    -ms-transition: opacity 0.5s ease-out;
    -o-transition: opacity 0.5s ease-out;
}


.insights-toggle-button svg {
    position: relative;
    top: 50% !important;
    left: 50%;
    transform: translate(-50%, -50%);
}

.insights-toggle-button.light {
    background: #FFFFFF;
    border: 0.5px solid #DADADA;
    --insights-toggle-button-border: #605CF4;
}

.insights-toggle-button.light rect {
    fill: #FFFFFF;
}

.insights-toggle-button.light path {
    fill: #605CF4;
}

.insights-toggle-button.light.active {
    background: #EFEFFE;
    border: 0.5px solid #605CF4;
}

.insights-toggle-button.dark {
    background: #323943;
    border: 0.5px solid #555555;
    --insights-toggle-button-border: #A5A3FA;
}

.insights-toggle-button.dark rect {
    fill: #FFFFFF;
}

.insights-toggle-button.dark path {
    fill: #A5A3FA;
}

.insights-toggle-button.dark.active {
    background: #424176;
    border: 0.5px solid #A5A3FA;
}

.insights-outer-container:hover .insights-toggle-button {
    visibility: visible;
    box-shadow: 0px 0px 20px 5px var(--insights-toggle-button-border);
    animation: heartbeatPulse 2s ease 0s 1 normal forwards;
}

.insights-outer-container:hover .insights-toggle-button.active {
    box-shadow: 0px 0px 0px 0px var(--insights-toggle-button-border) !important;
}

@keyframes heartbeatPulse {
    0% {
        animation-timing-function: ease-out;
        transform: scale(1);
        transform-origin: center center;
    }

    10% {
        animation-timing-function: ease-in;
        transform: scale(0.95);
    }

    17% {
        animation-timing-function: ease-out;
        transform: scale(0.98);
    }

    33% {
        animation-timing-function: ease-in;
        transform: scale(0.92);
    }

    45% {
        animation-timing-function: ease-out;
        transform: scale(1);
    }
}

/* Icons */
.insights-main-icon {
    background-color: var(--insights-main-icon-background-color);
    border: 2px;
    height: 32px;
    width: 32px;
    border-radius: 50%;
}

.insights-main-icon rect {
    fill: var(--insights-main-icon-rect-fill);
}

.insights-main-icon path {
    fill: var(--insights-accent);
}

.insights-main-icon svg {
    position: relative;
    top: 50% !important;
    left: 50%;
    transform: translate(-50%, -50%);
}

.insights-exit-btn,
.insights-refresh-btn {
    fill: var(--insights-right-icon-exit-fill);
}


.insights-refresh-new-btn {
    color: var(--insights-refresh-refresh-new-btn-color);
    font-weight: 600;
    background-color: var(--insights-refresh-refresh-new-btn-background-color);
    border: none;
    border-radius: 5px !important;
    padding: 2px 10px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    -webkit-border-radius: 5px !important;
    -moz-border-radius: 5px !important;
    -ms-border-radius: 5px !important;
    -o-border-radius: 5px !important;
}

.insights-refresh-new-btn path {
    fill: var(--insights-refresh-refresh-new-btn-path-fill);
}

.insights-stop-generating-btn {
    color: var(--insights-refresh-stop-generating-btn-color);
    font-weight: 600;
    background-color: var(--insights-refresh-stop-generating-btn-background-color);
    border: none;
    border-radius: 5px !important;
    padding: 5px 10px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    -webkit-border-radius: 5px !important;
    -moz-border-radius: 5px !important;
    -ms-border-radius: 5px !important;
    -o-border-radius: 5px !important;
}

.insights-stop-generating-btn path {
    fill: var(--insights-refresh-stop-generating-btn-path-fill);
}

/* loader */
.insights-loader-background-color {
    stop-color: var(--insights-loader-background-color);
}

.insights-loader-foreground-color {
    stop-color: var(--insights-loader-foreground-color);
}`, "",{"version":3,"sources":["webpack://./src/insights/insights.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,0BAA0B;IAC1B,yCAAyC;IACzC,mCAAmC;IACnC,6CAA6C;IAC7C,wCAAwC;IACxC,8CAA8C;IAC9C,uCAAuC;IACvC,wCAAwC;IACxC,gEAAgE;IAChE,qDAAqD;IACrD,yDAAyD;IACzD,4DAA4D;IAC5D,iDAAiD;IACjD,qDAAqD;IACrD,2CAA2C;IAC3C,2CAA2C;IAC3C,0DAA0D;IAC1D,0DAA0D;IAC1D,2CAA2C;IAC3C,gCAAgC;IAChC,8BAA8B;IAC9B,kCAAkC;IAClC,+BAA+B;IAC/B,qCAAqC;IACrC,iDAAiD;AACrD;;AAEA,wBAAwB;AACxB;;IAEI,0BAA0B;IAC1B,yCAAyC;IACzC,mCAAmC;IACnC,6CAA6C;IAC7C,wCAAwC;IACxC,8CAA8C;IAC9C,uCAAuC;IACvC,wCAAwC;IACxC,gEAAgE;IAChE,qDAAqD;IACrD,yDAAyD;IACzD,4DAA4D;IAC5D,iDAAiD;IACjD,qDAAqD;IACrD,2CAA2C;IAC3C,2CAA2C;IAC3C,uDAAuD;IACvD,uDAAuD;IACvD,2CAA2C;IAC3C,gCAAgC;IAChC,8BAA8B;IAC9B,kCAAkC;IAClC,6BAA6B;IAC7B,mCAAmC;IACnC,iDAAiD;AACrD;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,iCAAiC;AACrC;;AAEA;;;;;IAKI,0BAA0B;IAC1B,wBAAwB;IACxB,wBAAwB;IACxB,sBAAsB;IACtB,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,UAAU;IACV,uDAAuD;IACvD,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,YAAY;IACZ,wCAAwC;AAC5C;;;;AAIA,YAAY;AACZ;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;;;IAGI,OAAO;IACP,aAAa;AACjB;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,QAAQ;AACZ;;AAEA;;IAEI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,oBAAoB;AACpB;IACI,kCAAkC;IAClC,sCAAsC;IACtC,kBAAkB;IAClB,YAAY;IACZ,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,qCAAqC;IACrC,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB,0CAA0C;IAC1C,cAAc;IACd,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,4BAA4B;AAChC;;;AAGA,mBAAmB;AACnB;IACI,aAAa;IACb,uBAAuB;IACvB,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA,SAAS;AACT;IACI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,YAAY;IACZ;AACJ;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ;AACJ;;AAEA,aAAa;AACb;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,qDAAqD;IACrD,2CAA2C;IAC3C,gBAAgB;IAChB,0BAA0B;IAC1B,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;IACI,mDAAmD;IACnD,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;IAC7B,wBAAwB;IACxB,oCAAoC;AACxC;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;;IAEI,aAAa;IACb,wCAAwC;IACxC,kBAAkB;IAClB,4BAA4B;IAC5B,6BAA6B;IAC7B,mDAAmD;IACnD,8BAA8B;AAClC;;AAEA;;IAEI,4BAA4B;IAC5B,6BAA6B;AACjC;;;AAGA;IACI,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;;;;;;;IAOI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA,eAAe;AACf;IACI,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;AACvC;;AAEA;IACI,UAAU;IACV,iCAAiC;IACjC,yCAAyC;IACzC,sCAAsC;IACtC,qCAAqC;IACrC,oCAAoC;AACxC;;;AAGA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,iEAAiE;IACjE,sDAAsD;AAC1D;;AAEA;IACI,2EAA2E;AAC/E;;AAEA;IACI;QACI,mCAAmC;QACnC,mBAAmB;QACnB,+BAA+B;IACnC;;IAEA;QACI,kCAAkC;QAClC,sBAAsB;IAC1B;;IAEA;QACI,mCAAmC;QACnC,sBAAsB;IAC1B;;IAEA;QACI,kCAAkC;QAClC,sBAAsB;IAC1B;;IAEA;QACI,mCAAmC;QACnC,mBAAmB;IACvB;AACJ;;AAEA,UAAU;AACV;IACI,4DAA4D;IAC5D,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,gCAAgC;AACpC;;AAEA;;IAEI,0CAA0C;AAC9C;;;AAGA;IACI,oDAAoD;IACpD,gBAAgB;IAChB,0EAA0E;IAC1E,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,qCAAqC;IACrC,kCAAkC;IAClC,iCAAiC;IACjC,gCAAgC;AACpC;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,wDAAwD;IACxD,gBAAgB;IAChB,8EAA8E;IAC9E,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,qCAAqC;IACrC,kCAAkC;IAClC,iCAAiC;IACjC,gCAAgC;AACpC;;AAEA;IACI,2DAA2D;AAC/D;;AAEA,WAAW;AACX;IACI,mDAAmD;AACvD;;AAEA;IACI,mDAAmD;AACvD","sourcesContent":["/* Base variables */\n:root {\n    --insights-accent: #3B36F1;\n    --insights-body-background-color: #FFFFFF;\n    --insights-hover-btn-color: #FFFFFF;\n    --insights-question-input-background: #F2F1FD;\n    --insights-question-input-color: #6F8290;\n    --insights-main-icon-background-color: #EFEFFE;\n    --insights-main-icon-rect-fill: #fbf796;\n    --insights-right-icon-exit-fill: #1F222A;\n    --insights-refresh-stop-generating-btn-background-color: #FAEAEA;\n    --insights-refresh-stop-generating-btn-color: #B2201A;\n    --insights-refresh-stop-generating-btn-path-fill: #B2201A;\n    --insights-refresh-refresh-new-btn-background-color: #E9F9E7;\n    --insights-refresh-refresh-new-btn-color: #1E5C29;\n    --insights-refresh-refresh-new-btn-path-fill: #1E5C29;\n    --insights-loader-foreground-color: #eeeef1;\n    --insights-loader-background-color: #dadadd;\n    --insights-gradient-background-max: rgba(255, 255, 255, 1);\n    --insights-gradient-background-min: rgba(255, 255, 255, 0);\n    --insights-answer-reply-background: #EFEFFE;\n    --insights-header-color: #000000;\n    --insights-text-color: #47535C;\n    --insights-question-color: #1F222A;\n    --insights-scrollbar: #3c36f1c0;\n    --insights-scrollbar-hover: #3c36f156;\n    --insights-modal-shadow: 0px 0px 50px 0px #474747;\n}\n\n/* Dark mode overrides */\n:root.dark-mode,\n.insights-dark-mode {\n    --insights-accent: #A5A3FA;\n    --insights-body-background-color: #23272F;\n    --insights-hover-btn-color: #23272F;\n    --insights-question-input-background: #333A45;\n    --insights-question-input-color: #8B91A7;\n    --insights-main-icon-background-color: #333A45;\n    --insights-main-icon-rect-fill: #333A45;\n    --insights-right-icon-exit-fill: #EBECF0;\n    --insights-refresh-stop-generating-btn-background-color: #404756;\n    --insights-refresh-stop-generating-btn-color: #FA9494;\n    --insights-refresh-stop-generating-btn-path-fill: #FA9494;\n    --insights-refresh-refresh-new-btn-background-color: #404756;\n    --insights-refresh-refresh-new-btn-color: #B3ECAC;\n    --insights-refresh-refresh-new-btn-path-fill: #B3ECAC;\n    --insights-loader-foreground-color: #434B5B;\n    --insights-loader-background-color: #333A45;\n    --insights-gradient-background-max: rgba(35, 39, 47, 1);\n    --insights-gradient-background-min: rgba(35, 39, 47, 0);\n    --insights-answer-reply-background: #333A45;\n    --insights-header-color: #EBECF0;\n    --insights-text-color: #C5C8D3;\n    --insights-question-color: #EBECF0;\n    --insights-scrollbar: #A5A3FA;\n    --insights-scrollbar-hover: #8482C8;\n    --insights-modal-shadow: 0px 0px 50px 0px #474747;\n}\n\n.insights {\n    position: absolute;\n    user-select: text !important;\n    color: var(--insights-text-color);\n}\n\n.insights h1,\n.insights h2,\n.insights h3,\n.insights h4,\n.insights h5 {\n    margin-block-start: 0.67em;\n    margin-block-end: 1.34em;\n    margin-inline-start: 0px;\n    margin-inline-end: 0px;\n    color: var(--insights-header-color);\n    font-weight: 700;\n}\n\n.insights * {\n    font-family: noto sans !important;\n}\n\n.insights-body {\n    z-index: 2;\n    background-color: var(--insights-body-background-color);\n    border-radius: 5px;\n    border: none;\n    position: absolute;\n    top: 0;\n    right: 2rem;\n    width: 391px;\n    box-shadow: var(--insights-modal-shadow);\n}\n\n\n\n/*  header */\n.insights-header {\n    display: flex;\n    justify-content: space-between;\n    cursor: move;\n    padding-left: 9px !important;\n    padding-right: 9px !important;\n}\n\n.insights-left,\n.insights-middle,\n.insights-right {\n    flex: 1;\n    display: flex;\n}\n\n.insights-left,\n.insights-right {\n    padding-top: 11px !important;\n}\n\n.insights-right {\n    gap: 7px;\n}\n\n.insights-left .insights-hover-container,\n.insights-right .insights-hover-container {\n    position: relative;\n    display: inline-block;\n}\n\n/* info hover card */\n.insights-left .insights-hover-btn {\n    background: var(--insights-accent);\n    color: var(--insights-hover-btn-color);\n    border-radius: 4px;\n    border: none;\n    transition: background-color 0.3s;\n    padding: 4px 8px;\n    font-size: 12px;\n}\n\n.insights-hover-card {\n    cursor: auto;\n    white-space: wrap;\n    display: none;\n    position: absolute;\n    top: 70%;\n    padding: 5px 10px 5px 10px !important;\n    border: 1px solid #ccc;\n    background: #47535CE5;\n    border-radius: 5px;\n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n    color: #FFFFFF;\n    z-index: 3;\n    text-wrap: nowrap;\n    font-weight: 400;\n    font-size: 12px;\n    overflow: hidden;\n    word-wrap: break-word;\n}\n\n.insights-text strong {\n    font-size: revert !important;\n}\n\n.insights-left .insights-hover-card {\n    left: 0;\n}\n\n.insights-right .insights-hover-card {\n    right: 0;\n}\n\n\n.insights-hover-container:hover .insights-hover-card {\n    display: block;\n}\n\n.insights-right {\n    justify-content: flex-end;\n    /* max-width: 30%; */\n}\n\n.insights-right svg {\n    cursor: pointer;\n}\n\n.insights-middle {\n    flex-direction: column;\n    align-items: center;\n    padding-top: 20px !important;\n}\n\n\n/* next row title */\n.insights-title {\n    display: flex;\n    justify-content: center;\n    padding-top: 16px !important;\n    padding-bottom: 24px !important;\n}\n\n.insights-title-text {\n    font-weight: 700 !important;\n    font-size: 18px;\n    line-height: 24.51px;\n    text-align: center;\n}\n\n/* body */\n.insights-response-container {\n    min-height: 10rem;\n    overflow-y: auto;\n    max-height: 300px;\n    overflow-x: hidden;\n    white-space: break-spaces;\n}\n\n.insights-gradient-top {\n    position: sticky;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 50px;\n    background: linear-gradient(var(--insights-gradient-background-max), var(--insights-gradient-background-min))\n}\n\n.insights-gradient-bottom {\n    position: sticky;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 50px;\n    background: linear-gradient(var(--insights-gradient-background-min), var(--insights-gradient-background-max))\n}\n\n/* question */\n.insights-question {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 16px !important;\n}\n\n.insights-question-input {\n    flex-grow: 1;\n    border: 0px;\n    border-radius: 10px;\n    padding: 10px;\n    background: var(--insights-question-input-background);\n    color: var(--insights-question-input-color);\n    font-weight: 600;\n    font-size: 14px !important;\n    line-height: 16.34px !important;\n    border: 1px solid transparent;\n}\n\n.insights-question-input:focus {\n    border: 1px solid var(--insights-accent) !important;\n    outline: none !important;\n}\n\n.insights-question-input:hover {\n    border: 1px solid transparent;\n    outline: none !important;\n    border-color: transparent !important;\n}\n\n/* answer - question pair */\n.question-pair-border-top {\n    position: relative;\n    left: 50%;\n    width: 77%;\n    border-top: 1px solid #C8CFD4;\n    transform: translateX(-50%);\n}\n\n.insights-question-answer-pair {\n    padding-top: 10px;\n    padding-bottom: 5px;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    color: var(--insights-text-color);\n}\n\n.insights-answer-question {\n    padding-top: 1rem !important;\n    font-weight: 700;\n    margin-left: 0.7rem !important;\n    padding-bottom: 0.5rem !important;\n}\n\n.insights-current-reply,\n.insights-answer-reply {\n    display: flex;\n    border: solid 1px var(--insights-accent);\n    border-radius: 4px;\n    margin-left: 19px !important;\n    margin-right: 19px !important;\n    background: var(--insights-answer-reply-background);\n    margin-bottom: 15px !important;\n}\n\n.insights-current-reply>.insights-main-icon,\n.insights-answer-reply>.insights-main-icon {\n    padding-top: 11px !important;\n    padding-right: 8px !important;\n}\n\n\n.insights-text {\n    padding-left: 0.9rem !important;\n    padding-right: 0.9rem !important;\n}\n\n.insights-text strong,\n.insights-text h1,\n.insights-text h2,\n.insights-text h3,\n.insights-text h4,\n.insights-text h5,\n.insights-text h6 {\n    font-size: larger;\n}\n\n.insights-text *:not(strong):not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {\n    font-size: 12px;\n}\n\n/* scroll bar */\n.insights-response-container::-webkit-scrollbar {\n    width: 8px;\n    background-color: none;\n}\n\n.insights-response-container::-webkit-scrollbar-thumb {\n    background-color: var(--insights-scrollbar);\n    border-radius: 5px;\n    transition: background-color 0.2s;\n}\n\n.insights-response-container::-webkit-scrollbar-thumb:hover {\n    background-color: var(--insights-scrollbar-hover);\n}\n\n.insights-response-container::-webkit-scrollbar-button {\n    display: none;\n}\n\n.insights-uninitialized {\n    text-align: center;\n    padding-top: 20px;\n}\n\n.insights-error {\n    margin-top: 2rem;\n}\n\n.insights-outer-container {\n    position: relative;\n}\n\n.insights-toggle-button {\n    position: absolute;\n    z-index: 1;\n    cursor: pointer;\n    border-radius: 50%;\n    height: 32px;\n    width: 32px;\n    box-shadow: none;\n    transition: box-shadow 1s;\n}\n\n.insights-toggle-button-hidden {\n    opacity: 0;\n    transition: opacity 0.5s ease-in;\n    -webkit-transition: opacity 0.5s ease-in;\n    -moz-transition: opacity 0.5s ease-in;\n    -ms-transition: opacity 0.5s ease-in;\n    -o-transition: opacity 0.5s ease-in;\n}\n\n.insights-outer-container:hover .insights-toggle-button-hidden {\n    opacity: 1;\n    transition: opacity 0.5s ease-out;\n    -webkit-transition: opacity 0.5s ease-out;\n    -moz-transition: opacity 0.5s ease-out;\n    -ms-transition: opacity 0.5s ease-out;\n    -o-transition: opacity 0.5s ease-out;\n}\n\n\n.insights-toggle-button svg {\n    position: relative;\n    top: 50% !important;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.insights-toggle-button.light {\n    background: #FFFFFF;\n    border: 0.5px solid #DADADA;\n    --insights-toggle-button-border: #605CF4;\n}\n\n.insights-toggle-button.light rect {\n    fill: #FFFFFF;\n}\n\n.insights-toggle-button.light path {\n    fill: #605CF4;\n}\n\n.insights-toggle-button.light.active {\n    background: #EFEFFE;\n    border: 0.5px solid #605CF4;\n}\n\n.insights-toggle-button.dark {\n    background: #323943;\n    border: 0.5px solid #555555;\n    --insights-toggle-button-border: #A5A3FA;\n}\n\n.insights-toggle-button.dark rect {\n    fill: #FFFFFF;\n}\n\n.insights-toggle-button.dark path {\n    fill: #A5A3FA;\n}\n\n.insights-toggle-button.dark.active {\n    background: #424176;\n    border: 0.5px solid #A5A3FA;\n}\n\n.insights-outer-container:hover .insights-toggle-button {\n    visibility: visible;\n    box-shadow: 0px 0px 20px 5px var(--insights-toggle-button-border);\n    animation: heartbeatPulse 2s ease 0s 1 normal forwards;\n}\n\n.insights-outer-container:hover .insights-toggle-button.active {\n    box-shadow: 0px 0px 0px 0px var(--insights-toggle-button-border) !important;\n}\n\n@keyframes heartbeatPulse {\n    0% {\n        animation-timing-function: ease-out;\n        transform: scale(1);\n        transform-origin: center center;\n    }\n\n    10% {\n        animation-timing-function: ease-in;\n        transform: scale(0.95);\n    }\n\n    17% {\n        animation-timing-function: ease-out;\n        transform: scale(0.98);\n    }\n\n    33% {\n        animation-timing-function: ease-in;\n        transform: scale(0.92);\n    }\n\n    45% {\n        animation-timing-function: ease-out;\n        transform: scale(1);\n    }\n}\n\n/* Icons */\n.insights-main-icon {\n    background-color: var(--insights-main-icon-background-color);\n    border: 2px;\n    height: 32px;\n    width: 32px;\n    border-radius: 50%;\n}\n\n.insights-main-icon rect {\n    fill: var(--insights-main-icon-rect-fill);\n}\n\n.insights-main-icon path {\n    fill: var(--insights-accent);\n}\n\n.insights-main-icon svg {\n    position: relative;\n    top: 50% !important;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.insights-exit-btn,\n.insights-refresh-btn {\n    fill: var(--insights-right-icon-exit-fill);\n}\n\n\n.insights-refresh-new-btn {\n    color: var(--insights-refresh-refresh-new-btn-color);\n    font-weight: 600;\n    background-color: var(--insights-refresh-refresh-new-btn-background-color);\n    border: none;\n    border-radius: 5px !important;\n    padding: 2px 10px;\n    font-size: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    -webkit-border-radius: 5px !important;\n    -moz-border-radius: 5px !important;\n    -ms-border-radius: 5px !important;\n    -o-border-radius: 5px !important;\n}\n\n.insights-refresh-new-btn path {\n    fill: var(--insights-refresh-refresh-new-btn-path-fill);\n}\n\n.insights-stop-generating-btn {\n    color: var(--insights-refresh-stop-generating-btn-color);\n    font-weight: 600;\n    background-color: var(--insights-refresh-stop-generating-btn-background-color);\n    border: none;\n    border-radius: 5px !important;\n    padding: 5px 10px;\n    font-size: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    -webkit-border-radius: 5px !important;\n    -moz-border-radius: 5px !important;\n    -ms-border-radius: 5px !important;\n    -o-border-radius: 5px !important;\n}\n\n.insights-stop-generating-btn path {\n    fill: var(--insights-refresh-stop-generating-btn-path-fill);\n}\n\n/* loader */\n.insights-loader-background-color {\n    stop-color: var(--insights-loader-background-color);\n}\n\n.insights-loader-foreground-color {\n    stop-color: var(--insights-loader-foreground-color);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
